import React from "react";
import { CloseSquare } from "iconsax-react";

import { StyledCloseButton } from "./styledCloseButton";

const CloseButtonComponent = ({ className, closeFunction, iconSize }) => {
  return (
    <StyledCloseButton
      className={`${className ? className : undefined} bg-transparent`}
      onClick={closeFunction}
    >
      <CloseSquare size={iconSize} />
    </StyledCloseButton>
  );
};

export default CloseButtonComponent;
